export default __webpack_public_path__ + "static/media/fours.3c9000d9.jpeg";